import React, { useState, useEffect } from "react";
import TabsComponent from "../../Components/Categories/TabsComponent/TabsComponent";
import Servies from "../../Components/Servies/Servies";
import styles from "../../Components/Servies/Servies.module.css";
import SearchComponent from "../../Components/Utilities/SearchComponent";
import { useTranslation } from "react-i18next";
import { getAllServices } from "../../redux/Slices/Services/thunk";
import { useDispatch , useSelector} from 'react-redux';
import { useNavigate } from "react-router-dom";

const ServiesPage = () => {
  const { t, i18n } = useTranslation();
  const currentLanguage = i18n.language;
  const navigate = useNavigate();
  const storedCard = JSON.parse(localStorage.getItem("card"));
  const branchId = JSON.parse(localStorage.getItem("branchId"));
  const dispatch = useDispatch();
  console.log("MainCard", storedCard);
  const [selectedOption, setSelectedOption] = useState(null);
  const [externalTab, setExternalTab] = useState(1);

useEffect(()=>{
  if(!branchId){
    navigate('/branches')
  }
   if(!storedCard ){
    setExternalTab(0)
    navigate('/categories')
    console.log("mokhtar")
  }
  else{
    dispatch(getAllServices({branchId: branchId , Category:storedCard?.cats_num}))
  }
},[])

 

  // const handleCardClick = (tabIndex) => {
  //   setExternalTab(tabIndex);
  // };

  return (
    <div className='flex-grow-1'>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <TabsComponent externalTab={externalTab}  setExternalTab={setExternalTab} />
      </div>
      <div className={styles.loginContainer}>
        <div className={styles.loginHeader}>{t('services')}</div>
        <div className={styles.loginSecHeader}>
          {t('browse_specialized_services')}
        </div>
      </div>

      <Servies  />
    </div>
  );
};
export default ServiesPage;
